import { IValidatorError } from '../interfaces/validator-error.interface.js';
import { IValidatorOptions } from '../interfaces/validator-options.interface';

export class ValidatorOptions implements IValidatorOptions {
  error?: IValidatorError;
  validatorParameters: unknown[];

  constructor(data: IValidatorOptions) {
    this.validatorParameters = data?.validatorParameters || [];
    this.error = data?.error || undefined;
  }
}
